import React, { FC } from 'react';
import { Helmet } from 'react-helmet-async';
import styled from 'styled-components';
import PageHeader from '@/components/Layout/PageHeader';
import LegalCmsContent from '@/components/shared/LegalCmsContent';
import { useResponsibleGamingLoader } from '@/hooks/useResponsibleGamingLoader';

const StyledResponsibleGamingPage = styled.div`
  min-height: 100vh;
  position: relative;
`;

interface ResponsibleGamingPageProps {
  showHeader?: boolean;
}

const ResponsibleGamingPage: FC<ResponsibleGamingPageProps> = ({ showHeader = true }) => {
  const { data, loading } = useResponsibleGamingLoader();

  return (
    <StyledResponsibleGamingPage>
      {data && (
        <>
          <Helmet>
            <title>LuckyDays - {data.title}</title>
          </Helmet>
          {showHeader && (
            <PageHeader>
              <h1>{data.title}</h1>
            </PageHeader>
          )}
        </>
      )}

      <div className={`${showHeader ? 'pt-[60px]' : ''} px-4 sm:px-6 md:px-8 lg:px-0`}>
        <LegalCmsContent loading={loading} data={data} showTitle={false} />
      </div>
    </StyledResponsibleGamingPage>
  );
};

export default ResponsibleGamingPage;
